
import * as menuListItemsStyles from './MenuListItems.styles';

import MenuListItem from '../MenuListItem';
import { ExternalDomainLink, PrivateRoutePath, PublicRoutePath } from '../../../../utils/routes';
import { InvoiceGroup } from '../../../Orders/utils';
import { TrackingLinkEvent } from '../../../../utils/tracking/types';
import { allUnpaidOrders$, ordersByInvoiceGroup$ } from '../../../../store/entities/selectors';
import { referralProgramEligible$ } from '../../../../store/profile/selectors';

import { useTheme } from '@mui/material';
import { useSelector } from 'react-redux';
import List from '@mui/material/List';

export interface MenuListItemsProps {
  closeDrawer?: () => void;
  onSignout: () => void;
}

function MenuListItems({ onSignout, closeDrawer }: MenuListItemsProps) {
  const { classes } = menuListItemsStyles.useListStyles();

  const { palette } = useTheme();
  const overdueInvoices = useSelector(ordersByInvoiceGroup$(InvoiceGroup.OVERDUE));
  const dueSoonInvoices = useSelector(ordersByInvoiceGroup$(InvoiceGroup.DUE_BEFORE_END_OF_MONTH));
  const unpaidOrders = useSelector(allUnpaidOrders$);

  const referralProgramEligible = useSelector(referralProgramEligible$);
  const isReferralsVisible = referralProgramEligible;

  const ordersPresent = unpaidOrders.length > 0;

  const badge = {
    count: overdueInvoices.length || dueSoonInvoices.length,
    color: overdueInvoices.length ? palette.error.main : palette.warning.dark,
  };

  return (
    <List classes={classes} disablePadding>
      <MenuListItem
        icon="truckSilhouette"
        key="order-list-item"
        onClick={closeDrawer}
        primary="Orders"
        to={PrivateRoutePath.ORDERS}
      />

      <MenuListItem
        icon="quote"
        key="get-a-quote"
        onClick={closeDrawer}
        primary="Get a quote"
        to={PublicRoutePath.QUOTE_PROCESS_LOGIN}
        trackingLink={TrackingLinkEvent.NEW_QUOTE_BTN}
      />

      <MenuListItem
        icon="calendar"
        key="check-availability"
        onClick={closeDrawer}
        primary="Check availability"
        to={PublicRoutePath.AVAILABILITY}
        trackingLink={TrackingLinkEvent.MENU_CHECK_AVAILABILITY}
      />

      <MenuListItem
        icon="profile"
        key="profile-list-item"
        onClick={closeDrawer}
        primary="Profile"
        to={PrivateRoutePath.PROFILE}
      />

      <MenuListItem
        badge={badge}
        hide={!ordersPresent}
        icon="invoice"
        key="billing-list-item"
        onClick={closeDrawer}
        primary="Billing"
        to={PrivateRoutePath.BILLING}
      />

      <MenuListItem
        hide={!isReferralsVisible}
        icon="referrals"
        key="refer-tradie-list-item"
        onClick={closeDrawer}
        primary="Refer a tradie"
        to={PrivateRoutePath.REFERRALS}
      />

      <MenuListItem
        icon="lifebelt"
        key="contact-us-list-item"
        onClick={closeDrawer}
        primary="Help centre"
        to={ExternalDomainLink.SUPPORT}
        trackingLink={TrackingLinkEvent.HELP_CENTRE}
      />

      <MenuListItem icon="signout" key="signout-list-item" onClick={onSignout ?? closeDrawer} primary="Sign out" />
    </List>
  );
}

export default MenuListItems;
